import React from 'react'
import 'react-vis/dist/style.css'
import {
  RadarChart,
  makeWidthFlexible
} from 'react-vis'

const DATA = [
  { name: 'IN6012', nightvision: 10, megapixel: 2, power: 8, focal: 8, irleds: 10 },
  { name: 'IN3011', nightvision: 12, megapixel: 0.3, power: 7.6, focal: 6, irleds: 10 }
]

const FlexibleRadarChart = makeWidthFlexible(RadarChart)

export default class IN8015RadarIN6012 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      crosshairValues: []
    };
  }

  render() {
    return (
      <React.Fragment>

        <div className="chart">
          <FlexibleRadarChart
            data={DATA}
            startingAngle={0}
            domains={[
              { name: 'focal', domain: [6, 8] },
              { name: 'megapixel', domain: [0, 2] },
              { name: 'power', domain: [7, 8] },
              { name: 'nightvision', domain: [10, 12] },
              { name: 'irleds', domain: [10, 12] }
            ]}
            margin={{
              left: 50,
              right: 50
            }}
            width={400}
            height={275} />
        </div>

      </React.Fragment>
    );
  }
}